export {PLS} from './pls';
export {KOPLS} from './kopls';



// WEBPACK FOOTER //
// ./node_modules/ml-pls/src/index.js